/* AKOERA Night : slider photos des modèles (sans dépendance) */
(function () {
  'use strict';
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initSliders(root) {
    root.querySelectorAll('[data-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('[data-slides]');
      var slides = track ? track.children : [];
      var total = slides.length;
      if (!track || total < 2) return;
      var count = slider.querySelector('[data-slide-count]');
      var dots = slider.querySelectorAll('[data-slide-dot]');
      var prev = slider.querySelector('[data-slide-prev]');
      var next = slider.querySelector('[data-slide-next]');
      var current = 0;

      function render(i) {
        current = i;
        if (count) count.textContent = pad(i + 1) + ' / ' + pad(total);
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === total - 1;
      }
      function go(i) {
        i = Math.max(0, Math.min(total - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        render(i);
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== current) render(i);
        }, 60);
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      render(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initSliders(document); });
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
})();

/* AKOERA Night : choix rapide de la taille (gamme de modèles) */
(function () {
  'use strict';
  function initQuickAdd(root) {
    root.querySelectorAll('form.quick-add').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      var btn = form.querySelector('[data-qa-btn]');
      var label = form.querySelector('[data-qa-label]');
      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[name="id"]')) return;
        if (btn) btn.disabled = false;
        if (label) label.textContent = 'Ajouter au panier · ' + e.target.dataset.size;
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initQuickAdd(document); });
  document.addEventListener('shopify:section:load', function (e) { initQuickAdd(e.target); });
})();
